export const DOCUMENT_GROUP_TAGS = {
  DOCUMENT_GROUP_TAG: "DocumentGroup",
};
